import React from 'react';
import { ChevronDown } from 'react-bootstrap-icons';
import { formatSortRulesSummary } from './MultipleSort';
import './SortOrderField.scss';

export const getRemainingGridColSize = (colSizes = [], rowWidth = 12) => {
  const usedCols = colSizes.reduce((sum, col) => sum + col, 0) % rowWidth;
  return usedCols === 0 ? rowWidth : rowWidth - usedCols;
};

const SortOrderField = ({
  label = 'Sort Order',
  sortRules = [],
  sortFields = [],
  onClick,
  disabled = false,
  placeholder = 'Select sort order'
}) => {
  const summary = formatSortRulesSummary(sortRules, sortFields);

  return (
    <div>
      <h6 className="mb-2">{label}</h6>
      <button
        type="button"
        className="sort-order-field midFont"
        onClick={onClick}
        disabled={disabled}
        aria-label={`${label}: ${summary || placeholder}`}
      >
        <span className={`sort-order-field__value${summary ? '' : ' sort-order-field__value--placeholder'}`}>
          {summary || placeholder}
        </span>
        <ChevronDown size={14} className="sort-order-field__chevron" aria-hidden="true" />
      </button>
    </div>
  );
};

export default SortOrderField;
